import React from 'react'
import { connect } from 'react-redux'
import { ToggleFeature, features } from 'features/ToggleFeature'

const HeadMetadataContainer = (props) => {
  return (
    <ToggleFeature feature={features.HeadMetaData} {...props} />
  )
}

const mapStateToProps = ({ metadata, oidc }) => ({
  ...metadata,
  catalogId:
    oidc &&
    oidc.user &&
    oidc.user.profile &&
    oidc.user.profile['custom:catalog_id']
})

export default connect(mapStateToProps)(HeadMetadataContainer)



// WEBPACK FOOTER //
// ./src/Shared/HeadMetadata/HeadMetadataContainer.js